<template>
  <div class="testv__post__banner__wrapper">
    <TestvPostDate
      class="testv__post__banner__side"
      :date="post.released_time"
      :category="post.title_prefix"
    />
    <div class="testv__post__banner">
      <img :src="formatImageByImageMogr2(post.banner || 'https://cdn-static.sspai.com/page/testv/assets/placeholder.jpeg', { mode: 'crop', w: 1420, h: 708 })"/>
      <div class="testv__post__banner__title">{{ post.title }}</div>
    </div>
    <div class="testv__post__banner__count custom__cursor__pointer" @click="$emit('scrollToComment')">
      <IconComment class="icon__comment"/>
      <span>{{ total }}</span>
    </div>
  </div>
</template>

<script>
import { formatImageByImageMogr2 } from '@/utils/index.js'
import TestvPostDate from '@/components/TestvPostDate/index.vue'

export default {
  name: 'TestvPostBanner',

  components: {
    TestvPostDate
  },

  props: {
    post: Object,
    total: Number
  },

  methods: {
    formatImageByImageMogr2
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/styles/variable.styl"
.testv__post__banner__wrapper {
  position: relative;

  .testv__post__banner {
    position: relative;
    width: 100%;
    padding-top: (708 / 1420 * 100%);
    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.50) 100%);
      z-index: 2;
    }
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: 1;
    }
    .testv__post__banner__title {
      font-size: 20px;
      font-weight: 500;
      color: #fff;
      padding: 16px;
      color: var(--dark-bwb-8);
      position: absolute;
      left: 0;
      right: 40px;
      bottom: 0;
      z-index: 3;
      @media (min-width: $screen-md) {
        font-size: 40px;
        font-weight: 600;
        padding: 24px;
        right: 0;
      }
    }
  }
}

.testv__post__banner__side {
  position: absolute;
  z-index: 1;
  top: 16px;
  left: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--dark-bwb-8);
  row-gap: 8px;
  @media (min-width: $screen-md) {
    left: 0px;
    bottom: 0px;
    justify-content: space-between;
    transform: translateX(-100%);
    color: var(--dark-bwb-3);
  }
  @media (min-width: $screen-lg) {
    left: -16px;
  }
}

.testv__post__banner__count {
  position: absolute;
  z-index: 1;
  bottom: 16px;
  right: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 4px;
  font-size: 20px;
  font-weight: 500;
  color: var(--dark-bwb-8)
  font-family: 'DottedSongtiSquare';
  .icon__comment {
    width: 24px;
    height: 24px;
  }
  @media (min-width: $screen-md) {
    right: -16px;
    bottom: 0;
    transform: translateX(100%);
  }
}
</style>
